import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'

import {Observable, throwError} from 'rxjs'

import {catchError} from 'rxjs/operators'
import {MessageService} from "primeng/api";
import {Injectable} from "@angular/core";
import {SUPPRESS_ERROR_HANDLER} from "../service/crud/suppress-error-token";


@Injectable({
    providedIn: "root",
})
export class HttpErrorInterceptor implements HttpInterceptor {

    constructor(private messageService: MessageService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request)

            .pipe(

                // do not retry!
                //retry(1),

                catchError((error: HttpErrorResponse) => {

                    /*
                     * PER-REQUEST OPT-OUT — read before touching this.
                     *
                     * A caller that reports the failure itself, or that deliberately degrades in
                     * silence (a background enrichment read whose absence the UI already tolerates),
                     * sets SUPPRESS_ERROR_HANDLER on its HttpContext. It then receives the error
                     * object exactly as before, but without the global toast.
                     *
                     * This is an OPT-IN and not a change of the global contract: the token is
                     * declared as HttpContextToken<boolean>(() => false), so every request that does
                     * not set it reads false and keeps its error reporting unchanged. Suppression is
                     * for the surface, never for the error: this branch still rethrows, so the
                     * caller's own catchError/subscribe error path runs as it always did.
                     */
                    const suppressErrorHandling = request.context.get(SUPPRESS_ERROR_HANDLER);

                    if (error.error?.codes) {
                        return throwError(error);
                    }

                    if (suppressErrorHandling) {
                        // Skip error handling for this request
                        return throwError(error);
                    }

                    let err = {error: "", errorMessage:''}

                    if (error.error instanceof ErrorEvent) {
                        // client side error
                        err.errorMessage = `CLIENT: ${error.error.message}`;
                    } else {
                        let apiMessage = null;

                        if (error["error"]) {
                            apiMessage = error["error"];
                        }

                        // server side error
                        err.error = `${error.status} | ${error.name}`;
                        let url = new URL(error.url)
                        err.errorMessage = url.pathname

                        if(error.status === 0){
                            if(navigator.onLine){
                                err.errorMessage = 'Request could not send'
                            }
                            else {
                                err.errorMessage = 'no internet connection'
                            }
                        } else if(error.status === 500){
                            err.errorMessage = 'internal server error'

                        } else if(error.status === 403){
                            err.errorMessage = 'authentication failed'

                        } else if(error.status === 401){
                            // we do not need an error message for the microsoft LDAP calls
                            if (error.url == "https://graph.microsoft.com/v1.0/me" || error.url == "https://graph.microsoft.com/v1.0/me/photos/48x48/$value") {
                                err.errorMessage = ""; // no error message required
                            } else {
                                err.errorMessage = 'authentication/ authorization failed'
                            }
                        } else if(error.status === 404 && error.url.includes('photo/$')) {
                            // TODO: need to discuss with Marko how to handle this error
                            err.errorMessage = ''
                        } else if(error.status === 422) {
                            // 422 = validation response handled inline by the calling component
                            // (e.g. the uf flow form renders field-level errors from instanceErrors),
                            // so no global error toast is needed (empty errorMessage = no toast).
                            err.errorMessage = ''
                        }else{
                            if (error["error"] && error["error"]["data"]) {
                                // show the error DATA
                                err.errorMessage = error["error"]["data"];
                            } else {
                                err.errorMessage = error.message
                            }
                        }

                    }

                    if(err.errorMessage != ''){
                        this.messageService.add({severity:'error', summary: `${err.error}`, detail: err.errorMessage});
                    }
                    return throwError(error)
                })
            )
    }
}
